import { useMemo } from 'react'
import { useGetProvidersUserId } from '@/api/generated/doctor/doctor'
import type { TreatmentCenterApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'

export function useProviderLocations(providerId: string | undefined): {
  providerLocations: TreatmentCenterApiOutContract[]
  isLoading: boolean
} {
  const { data, isLoading } = useGetProvidersUserId(providerId ?? '', {
    query: { enabled: !!providerId },
  })

  // Every treatment center across all of the provider's licenses (deduped). The
  // dropdown shows all of them; the saved availability is confined to the chosen
  // center's state at submit time.
  const providerLocations = useMemo(() => {
    const all = (data?.Licenses ?? []).flatMap((license) =>
      (license.VisitTypes ?? []).flatMap((vt) => vt.TreatmentCenters ?? []),
    )
    return [...new Map(all.map((tc) => [tc.TreatmentCenterId, tc])).values()]
  }, [data])

  return { providerLocations, isLoading }
}
